import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {I18n} from 'react-redux-i18n';

import config from '../../../../../config';

import {recordGAEvent} from '../../../../utils/analytics';
import {VITRINE_ACCESSED} from '../../../../utils/constant';
import {getVitrineUrl} from '../../../../utils/path';
import {toggleModal} from '../../../../actions/modals';

import AccessVitrineModal from './AccessVitrineModal';
import {pathResolver} from '../../../../utils/basePathHelper';

const icon = <img
  alt="icon vitrine"
  src={pathResolver('resources/img/icon_vitrine.png')}
  style={{width: '100%'}}
/>;

function gaEventOpenedModal() {
  recordGAEvent('Vitrine', 'Opened Vitrine modal from sidebar menu');
}

function gaEventAccess() {
  recordGAEvent('Vitrine', 'Accessed Vitrine from sidebar menu');
}

function AccessVitrineButton() {
  const dispatch = useDispatch();
  const organisation = useSelector(state => state.organisation);
  const url = React.useMemo(() => getVitrineUrl(organisation?.organisationId), [organisation?.organisationId]);
  if (!config?.featureFlags?.showAccessVitrineButton || !organisation) { return null; }

  function openModal() {
    gaEventOpenedModal();
    dispatch(toggleModal('accessVitrineModal', true));
  }

  if (localStorage.getItem(VITRINE_ACCESSED)) {
    return (
      <a
        target="_blank"
        onClick={gaEventAccess}
        href={url}
        className="button-square px-1 flex-container"
        rel="noopener noreferrer"
        title={I18n.t('menu.vitrine')}
      >
        {icon}
      </a>
    );
  }

  return (
    <>
      <button
        onClick={openModal}
        className="button-square px-1 flex-container"
        title={I18n.t('menu.vitrine')}
      >
        {icon}
      </button>
      <AccessVitrineModal/>
    </>
  );
}

export default AccessVitrineButton;
